var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrmTools(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1083_3018)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.2998 11.5498H14.6998V15.4498H12.2998V11.5498Z",
    fill: "#9C9C9C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.75 15.75C15.75 15.9489 15.671 16.1397 15.5303 16.2803C15.3897 16.421 15.1989 16.5 15 16.5H12C11.8011 16.5 11.6103 16.421 11.4697 16.2803C11.329 16.1397 11.25 15.9489 11.25 15.75V14.25H1.5V21C1.5 21.3978 1.65804 21.7794 1.93934 22.0607C2.22064 22.342 2.60218 22.5 3 22.5H24C24.3978 22.5 24.7794 22.342 25.0607 22.0607C25.342 21.7794 25.5 21.3978 25.5 21V14.25H15.75V15.75Z",
    fill: "#9C9C9C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2825 9.285L22.215 6.2175C22.0753 6.07894 21.8868 6.00083 21.69 6H17.94V4.5375C17.9502 4.14341 17.8048 3.76117 17.5353 3.47344C17.2658 3.18571 16.8939 3.01564 16.5 3H10.38C10.1875 3.00757 9.9985 3.0537 9.82415 3.13563C9.6498 3.21757 9.49367 3.33366 9.36499 3.47702C9.23631 3.62039 9.13771 3.78811 9.07502 3.97027C9.01233 4.15243 8.98682 4.34531 9.00001 4.5375V6H5.31001C5.21131 5.99943 5.11346 6.01835 5.02208 6.05567C4.9307 6.093 4.84759 6.14799 4.77751 6.2175L1.71751 9.285C1.648 9.35508 1.59301 9.43819 1.55568 9.52957C1.51836 9.62095 1.49944 9.7188 1.50001 9.8175V12.75H11.25V11.25C11.25 11.0511 11.329 10.8603 11.4697 10.7197C11.6103 10.579 11.8011 10.5 12 10.5H15C15.1989 10.5 15.3897 10.579 15.5303 10.7197C15.671 10.8603 15.75 11.0511 15.75 11.25V12.75H25.5V9.81C25.4992 9.61325 25.4211 9.4247 25.2825 9.285ZM16.5 6H10.5V4.5H16.5V6Z",
    fill: "#9C9C9C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1083_3018"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 27,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrmTools);
export default __webpack_public_path__ + "static/media/crm-tools.81e5c645920b0653384743685f2fc061.svg";
export { ForwardRef as ReactComponent };